import { useEffect, useState } from 'react';
import api from '../api';

function SalesStats() {
  const [days, setDays] = useState(10);
  const [bestSelling, setBestSelling] = useState([]);
  const [returnsTop, setReturnsTop] = useState([]);
  const [unclaimedTop, setUnclaimedTop] = useState([]);
  const [unsoldProducts, setUnsoldProducts] = useState([]);
  const [zeroStockProducts, setZeroStockProducts] = useState([]);
  const [summary, setSummary] = useState({
    totalOutgoing: 0,
    totalReturns: 0,
    totalUnclaimed: 0,
    totalReturnedBack: 0,
    returnSharePercent: 0,
    unclaimedSharePercent: 0,
    totalBackRatePercent: 0,
    returnRatePercent: 0,
    unclaimedRatePercent: 0
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const fetchSalesStats = async () => {
    try {
      setLoading(true);
      setError('');

      const response = await api.get('/getSalesStats', {
        params: {
          days: days
        }
      });

      setBestSelling(response.data.bestSelling || []);
      setReturnsTop(response.data.returnsTop || []);
      setUnclaimedTop(response.data.unclaimedTop || []);
      setUnsoldProducts(response.data.unsoldProducts || []);
      setZeroStockProducts(response.data.zeroStockProducts || []);
      setSummary(
        response.data.summary || {
          totalOutgoing: 0,
          totalReturns: 0,
          totalUnclaimed: 0,
          totalReturnedBack: 0,
          returnSharePercent: 0,
          unclaimedSharePercent: 0,
          totalBackRatePercent: 0,
          returnRatePercent: 0,
          unclaimedRatePercent: 0
        }
      );
    } catch (err) {
      setError(
        (err && err.response && err.response.data && err.response.data.error) ||
          err.message ||
          'Nu am putut incarca analiza vanzarilor'
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSalesStats();
  }, []);

  return (
    <div style={pageStyle}>
      <h1 style={titleStyle}>Analiza vanzari</h1>
      <p style={subtitleStyle}>
        Toate topurile sunt calculate pe ultimele X zile si tin cont de retururi si neridicate.
      </p>

      <div style={cardStyle}>
        <div style={controlsWrapStyle}>
          <div>
            <label style={labelStyle}>Interval analiza</label>
            <select
              value={days}
              onChange={(e) => setDays(Number(e.target.value))}
              style={inputStyle}
            >
              <option value={5}>Ultimele 5 zile</option>
              <option value={10}>Ultimele 10 zile</option>
              <option value={20}>Ultimele 20 zile</option>
              <option value={30}>Ultimele 30 zile</option>
              <option value={60}>Ultimele 60 zile</option>
            </select>
          </div>

          <div style={buttonWrapStyle}>
            <button onClick={fetchSalesStats} style={buttonStyle}>
              Reincarca
            </button>
          </div>
        </div>
      </div>

      <div style={summaryGridStyle}>
        <SummaryCard label="Total plecate" value={summary.totalOutgoing || 0} />
        <SummaryCard label="Retururi" value={summary.totalReturns || 0} />
        <SummaryCard label="Retururi functionale" value={summary.totalReturnsFunctional || 0} />
        <SummaryCard label="Retururi nefunctionale" value={summary.totalReturnsNonFunctional || 0} />
        <SummaryCard label="Neridicate" value={summary.totalUnclaimed || 0} />
        <SummaryCard label="Total intoarse" value={summary.totalReturnedBack || 0} />
        <SummaryCard
          label="% Retur din intoarse"
          value={(summary.returnSharePercent || 0) + '%'}
        />
        <SummaryCard
          label="% Neridicat din intoarse"
          value={(summary.unclaimedSharePercent || 0) + '%'}
        />
        <SummaryCard
          label="% Intoarse din plecate"
          value={(summary.totalBackRatePercent || 0) + '%'}
        />
        <SummaryCard
          label="% Retur din plecate"
          value={(summary.returnRatePercent || 0) + '%'}
        />
        <SummaryCard
          label="% Neridicat din plecate"
          value={(summary.unclaimedRatePercent || 0) + '%'}
        />
      </div>

      {loading ? <div style={infoStyle}>Se incarca topurile...</div> : null}
      {error ? <div style={errorStyle}>{error}</div> : null}

      <div style={gridStyle}>
        <div style={cardStyle}>
          <h2 style={sectionTitleStyle}>Top 20 vandute net</h2>
          <StatsTable
            items={bestSelling}
            valueKey="netSold"
            valueLabel="Vandut net"
            emptyText="Nu exista vanzari in intervalul selectat."
          />
        </div>

        <div style={cardStyle}>
          <h2 style={sectionTitleStyle}>Top 20 retururi</h2>
          <StatsTable
            items={returnsTop}
            valueKey="returns"
            valueLabel="Retururi"
            emptyText="Nu exista retururi in intervalul selectat."
          />
        </div>

        <div style={cardStyle}>
          <h2 style={sectionTitleStyle}>Top 20 neridicate</h2>
          <StatsTable
            items={unclaimedTop}
            valueKey="unclaimed"
            valueLabel="Neridicate"
            emptyText="Nu exista neridicate in intervalul selectat."
          />
        </div>

        <div style={cardStyle}>
          <h2 style={sectionTitleStyle}>Produse fara vanzari</h2>
          <StatsTable
            items={unsoldProducts}
            valueKey="grossSold"
            valueLabel="Vandute"
            emptyText="Toate produsele au avut vanzari in interval."
          />
        </div>

        <div style={cardStyle}>
          <h2 style={sectionTitleStyle}>Produse cu stoc 0</h2>
          <StatsTable
            items={zeroStockProducts}
            valueKey="stock"
            valueLabel="Stoc"
            emptyText="Nu exista produse cu stoc 0."
          />
        </div>
      </div>
    </div>
  );
}

function StatsTable({ items, emptyText, valueKey, valueLabel }) {
  return (
    <div style={tableWrapStyle}>
      <table style={tableStyle}>
        <thead>
          <tr>
            <th style={thStyle}>Pozitie</th>
            <th style={thStyle}>Cod produs</th>
            <th style={thStyle}>Nume produs</th>
            <th style={thStyle}>Cod de bare</th>
            <th style={thStyle}>{valueLabel}</th>
          </tr>
        </thead>
        <tbody>
          {items.length === 0 ? (
            <tr>
              <td style={tdStyle} colSpan="5">
                {emptyText}
              </td>
            </tr>
          ) : (
            items.map((item, index) => (
              <tr key={item.id + '-' + index}>
                <td style={tdStyle}>{index + 1}</td>
                <td style={tdStyle}>{item.id}</td>
                <td style={tdStyle}>{item.productName}</td>
                <td style={tdStyle}>{item.barcode || '-'}</td>
                <td style={tdStyle}>{item[valueKey] || 0}</td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}

function SummaryCard({ label, value }) {
  return (
    <div style={summaryCardStyle}>
      <div style={summaryLabelStyle}>{label}</div>
      <div style={summaryValueStyle}>{value}</div>
    </div>
  );
}

const pageStyle = {
  maxWidth: '1600px',
  margin: '0 auto'
};

const titleStyle = {
  marginBottom: '8px',
  fontSize: '32px',
  color: '#111827'
};

const subtitleStyle = {
  marginTop: 0,
  marginBottom: '20px',
  color: '#4b5563'
};

const gridStyle = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(500px, 1fr))',
  gap: '20px'
};

const cardStyle = {
  background: '#ffffff',
  borderRadius: '12px',
  padding: '20px',
  boxShadow: '0 2px 10px rgba(0,0,0,0.08)',
  marginBottom: '20px'
};

const controlsWrapStyle = {
  display: 'flex',
  gap: '16px',
  alignItems: 'end',
  flexWrap: 'wrap'
};

const buttonWrapStyle = {
  display: 'flex',
  alignItems: 'end'
};

const summaryGridStyle = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
  gap: '16px',
  marginBottom: '20px'
};

const summaryCardStyle = {
  background: '#ffffff',
  borderRadius: '12px',
  padding: '18px',
  boxShadow: '0 2px 10px rgba(0,0,0,0.08)'
};

const summaryLabelStyle = {
  color: '#6b7280',
  fontSize: '14px',
  marginBottom: '8px'
};

const summaryValueStyle = {
  color: '#111827',
  fontWeight: '800',
  fontSize: '24px'
};

const sectionTitleStyle = {
  marginTop: 0,
  marginBottom: '16px',
  color: '#111827'
};

const labelStyle = {
  display: 'block',
  marginBottom: '8px',
  fontWeight: '600',
  color: '#111827'
};

const inputStyle = {
  width: '220px',
  padding: '12px',
  fontSize: '15px',
  border: '1px solid #d1d5db',
  borderRadius: '8px',
  boxSizing: 'border-box'
};

const buttonStyle = {
  background: '#2563eb',
  color: '#ffffff',
  border: 'none',
  borderRadius: '8px',
  padding: '12px 18px',
  fontWeight: '700',
  cursor: 'pointer'
};

const infoStyle = {
  background: '#e0f2fe',
  color: '#075985',
  padding: '12px 16px',
  borderRadius: '10px',
  marginBottom: '16px',
  fontWeight: '600'
};

const errorStyle = {
  background: '#fee2e2',
  color: '#991b1b',
  padding: '12px 16px',
  borderRadius: '10px',
  marginBottom: '16px',
  fontWeight: '600'
};

const tableWrapStyle = {
  overflowX: 'auto'
};

const tableStyle = {
  width: '100%',
  borderCollapse: 'collapse',
  minWidth: '700px'
};

const thStyle = {
  textAlign: 'left',
  padding: '12px',
  background: '#f3f4f6',
  borderBottom: '1px solid #e5e7eb',
  color: '#111827',
  fontSize: '14px',
  whiteSpace: 'nowrap'
};

const tdStyle = {
  padding: '12px',
  borderBottom: '1px solid #e5e7eb',
  fontSize: '14px',
  color: '#111827',
  whiteSpace: 'nowrap'
};

export default SalesStats;